/**
 * ThemePreset — a named bundle of GLOBAL-block settings.
 *
 * A theme is nothing the engine has to understand: every entry is a plain markdown key
 * (`backgroundGradientColor1`, `labelFontFamily`, `primaryRoughness`, ...) that the
 * MarkdownParser already routes to SceneSettingsData / AppSettingsData / LayoutData.
 * `theme: <name>` in the GLOBAL block expands to these entries BEFORE the explicit lines
 * of the block are applied, so an author (or the editor theme panel) can pick a preset
 * and still override single values underneath it.
 *
 * Presets deliberately carry only LOOK: background, light, material, label style. They
 * never set layouter, camera distance or spacing. Those belong to the content.
 */
export type ThemeValue = string | number | boolean;

export interface ThemePreset {
    /** Value used after `theme:` in markdown. Lowercase, kebab-case, stable. */
    readonly name: string;
    /** Short human label for the editor. */
    readonly label: string;
    readonly description: string;
    /** Markdown keys to values, applied through the parser's normal routing. */
    readonly values: Readonly<Record<string, ThemeValue>>;
}

/** Keys the editor theme panel exposes as overrides on top of a preset. */
export const THEME_OVERRIDE_KEYS = [
    'backgroundGradientColor1',
    'backgroundGradientColor2',
    'backgroundGradientAngle',
    'labelColor',
    'labelBackgroundColor',
    'labelFontFamily',
] as const;

export type ThemeOverrideKey = typeof THEME_OVERRIDE_KEYS[number];
